import { render } from "./add-job-view.vue?vue&type=template&id=73f6c5b6"
import script from "./add-job-view.vue?vue&type=script&lang=js"
export * from "./add-job-view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__